import { render } from "./GridRolurisiDrepturi.vue?vue&type=template&id=2ffe25f9&ts=true"
import script from "./GridRolurisiDrepturi.vue?vue&type=script&lang=ts"
export * from "./GridRolurisiDrepturi.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__